module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAWCAYAAAA4oUfxAAAA9UlEQVRIiWO8++jZfwYqA25OTqLUMVHbYlLAyLWcBZmTmJLP8PvXL4Yli6YzxMRlgsXwsWMTshjevHnHICEhzjB/zkSSLWdETnCePhEM27esINkQkINAjoEBshKciIgQToUgX+ICyBaTAlAsX7xgGk6F///hzpH4HEa05eT6Dp/DiLacXN+RG+woqZ1c34Echi3KuiYvxxAry42Es7EGOyj1wrIUjA3LZuji+ByGbBE2PkpWQ88yxPgOG0DPaqAQQLcYBFB8Tkmw4wPYLMawfESldroEO1GWk+s7UOVCseUsLKzgygVflsPGBtVq5ADG0WbUQAAAuPuON6+jArgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/kxtb1-2.png
// module id = 749
// module chunks = 0